var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePay = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 17 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M14.937 2.709a3.393 3.393 0 0 0-4.634 1.242L7.94 8.044c-.684 1.182.196 1.595 1.178 2.184l2.274 1.312a1.61 1.61 0 0 0 2.197-.588l2.43-4.207a2.954 2.954 0 0 0-1.082-4.036"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc04",
  d: "M12.263 4.403 9.989 3.091c-1.255-.697-1.966-.743-2.481.076L4.154 8.975a3.39 3.39 0 0 0 1.242 4.628 2.954 2.954 0 0 0 4.037-1.081l3.417-5.92a1.607 1.607 0 0 0-.587-2.199"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M12.7 1.418 11.103.495A3.693 3.693 0 0 0 6.06 1.847L3.018 7.113a1.624 1.624 0 0 0 .594 2.22l1.789 1.032c.883.51 2.012.208 2.522-.675l3.474-6.017a2.605 2.605 0 0 1 3.56-.953z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "m6.49 3.354-1.726-.995a1.61 1.61 0 0 0-2.197.588L.495 6.526a3.68 3.68 0 0 0 1.352 5.031l1.314.757 1.594.919.692.398a2.83 2.83 0 0 1-.867-3.767l.536-.926L7.08 5.544a1.603 1.603 0 0 0-.59-2.19"
})));
export default SvgGooglePay;